<template>
  <div class="login">
    <v-row class="justify-center">
      <v-col md="7" class="d-flex align-center">
        <div class="flex-fill">
          <h1 class="text-center my-10">
            ثبت نام
          </h1>
          <v-card outlined class="pa-5">
            <form-alert
              v-if="this.$store.getters.error"
              :message="this.$store.getters.error"
            />
            <v-form
              v-model="valid"
              @submit.prevent="handleSigninUser"
              class="text-center"
            >
              <v-text-field
                class="mb-3"
                v-model="username"
                :rules="usernameRules"
                outlined
                dense
                label="نام کاربری"
                required
              />
              <v-text-field
                class="mb-3"
                v-model="password"
                :rules="passwordRules"
                type="password"
                outlined
                dense
                label="کلمه عبور"
                required
              />
              <v-btn
                :loading="loading"
                :disabled="!valid || loading"
                block
                depressed
                color="success"
                type="submit"
              >
                ورود
              </v-btn>
            </v-form>
          </v-card>
        </div>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn class="mt-2" router to="/" text>
          بازگشت به صفحه اصلی
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
      loading: false,
      valid: true,
      username: "",
      usernameRules: [(u) => !!u || "لطفا تلفن همراه خود را وارد نمایید"],
      password: "",
      passwordRules: [(p) => !!p || "کلمه عبور خود را وارد نمایید"],
      confirmPassword: "",
      confirmPasswordRules: [(p) => !!p || "کلمه عبور خود را وارد نمایید"]
    };
  },
  methods: {
    handleSigninUser() {
      this.loading = true;
      this.$store.dispatch("signupUser", {
        username: this.username,
        password: this.password
      });
      this.loading = false;
    }
  }
};
</script>
